// extracted by mini-css-extract-plugin
module.exports = {"root":"Show-module__root___1jbv-"};